import React from 'react';
import { Tasks } from 'components/common/tasks';
import { PERMISSIONS } from 'constants/permissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { Row } from 'antd';

interface TasksEntityProps {
  forDashboard?: boolean;
  onTotalUpdate?: (total: number) => void;
}

export const TasksEntity = React.memo(({ forDashboard, onTotalUpdate }: TasksEntityProps) => {
  const { hasAccess } = useAccessControl();
  return (
    <Row style={{ paddingTop: '25px', marginLeft: '32px' }}>
      <Tasks
        hasAccessToWrite={hasAccess(PERMISSIONS.tasks.task.write)}
        hasAccessToDelete={hasAccess(PERMISSIONS.tasks.task.delete)}
        showAnalytics={!forDashboard}
        forDashboard={forDashboard}
        onTotalUpdate={onTotalUpdate}
        isMainTable={true}
      />
    </Row>
  );
});
